import { createYConnection } from '../../functions/createYConnection.js'
import { socketDisconnectedContainer, noConnectionContainer } from '../../functions/SocketIo.js'

let isDialogOpen = false
let dialogType = undefined

const getWarningText = elem => elem.querySelector('.warning-text').innerText

export default class yConnection {

  constructor (rundownInfo, $scope, $mdDialog) {
    this.connections = {}
    this.startListeners = {}
    this.promises = {}
    this.rundownInfo = rundownInfo
    this.$scope = $scope
    this.$mdDialog = $mdDialog
  }

  addConnection (id, connection) {
    id = (id || 0).toString()
    this.connections[id] = connection
  }

  deleteConnection (id) {
    id = (id || 0).toString()
    const yDoc = this.connections[id]
    yDoc.provider.destroy()
    yDoc.destroy()
    yDoc.provider.socketIo.addEventListener('connection', yDoc.connectionListener)

    delete this.connections[id]
    delete this.promises[id]
  }

  getConnection (id) {
    id = (id || 0).toString()
    return this.connections[id]
  }

  closeWarningDialog () {
    if (dialogType === 'warning') {
      dialogType = undefined
      if (isDialogOpen) {
        this.$mdDialog.hide()
      }
    }
  }

  openDialog (type, title) {
    // Skip when the dialog is already open
    if (dialogType) return

    // Do not open Dialog if StationSetting is true
    if (CONFIG.block_live_rundown_dialog) return

    dialogType = type
    isDialogOpen = true

    const { $mdDialog } = this
    const ok = document.getElementById('ok_translation').content
    const cancel = document.getElementById('refresh_to_connect_translation').content
    const contentDialog = $mdDialog.confirm({ multiple: true, title, cancel, ok })

    $mdDialog.show(contentDialog)
      .catch((err) => {
        console.log(err)
        location.reload()
      })
      .then(() => {
        isDialogOpen = false
      })
  }

  createConnection (id) {
    if (!this.promises[id]) {
      const stationId = this.rundownInfo.masterstation_id || CONFIG.station_id
      const roomName = 'rundown.block.' + stationId + '.' + id
      this.promises[id] = createYConnection(roomName)
        .then(yDoc => {
          this.connections[id] = yDoc

          yDoc.connectionListener = event => {
            switch (event.detail.state) {
              case 'green':
                this.closeWarningDialog()
                break
              case 'yellow':
                this.openDialog('warning', getWarningText(noConnectionContainer()))
                break
              case 'red':
                this.closeWarningDialog()
                this.openDialog('disconnected', getWarningText(socketDisconnectedContainer()))
                break
            }
          }

          yDoc.provider.socketIo.addEventListener('connection', yDoc.connectionListener)
          return yDoc
        })
    }
    return this.promises[id]
  }

  getConnections () {
    return this.connections
  }
}
